
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12 2.25c5.278 0 9.593 4.2 9.746 9.474l.004.276c0 5.278-4.2 9.593-9.474 9.746L12 21.75c-5.278 0-9.593-4.2-9.746-9.474L2.25 12c0-5.278 4.2-9.593 9.474-9.746zm0 1.5l-.244.004c-4.453.128-8.006 3.78-8.006 8.235l.004.255c.128 4.453 3.78 8.006 8.235 8.006l.255-.004c4.453-.128 8.006-3.78 8.006-8.235l-.004-.255A8.25 8.25 0 0012 3.75zm-.001 7.125l.122.007a1.125 1.125 0 11-.245 0l.123-.007zm4 0l.122.007a1.125 1.125 0 11-.245 0l.123-.007zm-8 0l.122.007a1.125 1.125 0 11-.245 0l.123-.007z","fill":"#FC6B36","fill-rule":"evenodd"}})])
          )
        }
      }
    